const $ = require('jquery');

window.initLocationAutoComplete = function () {
    const input = document.getElementById("pac-input-0");
    const latInput = document.getElementById("lat-input-0");
    const lonInput = document.getElementById("lon-input-0");
    const options = {
        types: ['(cities)'],
        componentRestrictions: {country: ['nl', 'be', 'de']}
    };
    const autocomplete = new google.maps.places.Autocomplete(input, options);

    autocomplete.setFields(["formatted_address", "geometry", "name"]);
    autocomplete.addListener("place_changed", () => {
        const location = autocomplete.getPlace();

        input.value = location.name;
        if (latInput !== null && lonInput !== null) {
            if (location.geometry && location.geometry.location) {
                latInput.value = location.geometry.location.lat();
                lonInput.value = location.geometry.location.lng();
            } else {
                latInput.value = '';
                lonInput.value = '';
            }
        }
    });

    if(window.hasOwnProperty('afterMapsLoaded')) {
        for(let index in window.afterMapsLoaded) {
            window.afterMapsLoaded[index]();
        }
    }
}

$(document).ready(() => {
    const latInput = document.getElementById("lat-input-0");
    const lonInput = document.getElementById("lon-input-0");
    const pacInput = document.getElementById("pac-input-0");
    const latInput2 = document.getElementById("lat-input-1");
    const lonInput2 = document.getElementById("lon-input-1");
    const pacInput2 = document.getElementById("pac-input-1");

    $('#button-current-location-0, #button-current-location-1').click(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                latInput.value = position.coords.latitude;
                lonInput.value = position.coords.longitude;
                latInput2.value = position.coords.latitude;
                lonInput2.value = position.coords.longitude;
                pacInput.value = position.coords.latitude + ', ' + position.coords.longitude;
                pacInput2.value = position.coords.latitude + ', ' + position.coords.longitude;
            });
        } else {
            console.log('Geolocation is not supported by this browser.');
        }
    });
});
